import { t } from "i18next";

export const genderOptions = [
    { id: 1, name: t("posts-master.views.male") },
    { id: 2, name: t("posts-master.views.female") },
];

export const triggerTypeOptions = [
    { id: 1, name: t("posts-master.views.trigger_type.event") },
    { id: 2, name: t("posts-master.views.trigger_type.frequency") },
];

export const eventTypeOptions = [
    { id: 1, name: t("posts-master.views.event_types.birthday") },
    { id: 2, name: t("posts-master.views.event_types.assisteds") },
    { id: 3, name: t("posts-master.views.event_types.lessons") },
    { id: 4, name: t("posts-master.views.event_types.days_assist") },
    { id: 5, name: t("posts-master.views.event_types.days_renewal") },
    { id: 6, name: t("posts-master.views.event_types.days_expired") },
    { id: 7, name: t("posts-master.views.event_types.next_evaluation") },
    { id: 8, name: t("posts-master.views.event_types.remaining_sessions") },
    { id: 9, name: t("posts-master.views.event_types.days_without_connection") },
];

export const sendingOptions = [
    { id: 1, name: t("posts-master.views.day_before") },
    { id: 2, name: t("posts-master.views.day_next") },
];

export const frequencyOptions = [
    { id: 1, name: t("posts-master.views.frequencies.once") },
    { id: 2, name: t("posts-master.views.frequencies.weekly") },
    { id: 3, name: t("posts-master.views.frequencies.monthly") },
];

export const dayOptions = Array.from({ length: 11 }, (_, i) => {
    const value = 10 - i;
    return { id: value, name: value.toString() };
});

export const dayExpiredOptions = Array.from({ length: 61 }, (_, i) => {
    const value = 60 - i;
    return { id: value, name: value.toString() };
});

export const daySessionsOptions = Array.from({ length: 10 }, (_, i) => {
    const value = 10 - i;
    return { id: value, name: value.toString() };
});
